import React, { useState } from 'react';
import { isFavorite, toggleFavorite } from '../data/favoritesStore';

interface FavoriteButtonProps {
  fieldId: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const FavoriteButton: React.FC<FavoriteButtonProps> = ({ fieldId, size = 'md', className = '' }) => {
  const [fav, setFav] = useState(() => isFavorite(fieldId));
  const [animate, setAnimate] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const newState = toggleFavorite(fieldId);
    setFav(newState);
    if (newState) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 400);
    }
  };

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <button
      onClick={handleClick}
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center transition-all duration-200 ${
        fav
          ? 'bg-red-50 hover:bg-red-100 text-red-500'
          : 'bg-white/80 backdrop-blur-sm hover:bg-white text-gray-400 hover:text-red-400'
      } shadow-sm border border-gray-200/50 ${animate ? 'scale-125' : 'scale-100'} ${className}`}
      title={fav ? 'Favorilerden Çıkar' : 'Favorilere Ekle'}
    >
      <svg
        className={`${iconSizes[size]} transition-transform duration-200 ${animate ? 'scale-110' : ''}`}
        fill={fav ? 'currentColor' : 'none'}
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </button>
  );
};

export default FavoriteButton;
